import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {trackAmplitudeViewSection} from "../../tracking/amplitude/track_amplitude_view_section";
import {IPersonalizedRecentSearch} from "../types/IPersonalizedHomepage";

/** Page-level impression of the personalized variant only — never sent for the generic homepage. */
export const trackPersonalizedHomepageViewPage = () => {
    trackAmplitudeEvent("view_page", {
        location: "homepage",
        homepage_variant: "personalized"
    });
};

export const trackPersonalizedHomepageRecentSearchesView = (params: {searches: IPersonalizedRecentSearch[]; startIndex?: number}) => {
    trackAmplitudeViewSection({
        sectionName: "recent_searches",
        location: "homepage",
        products: params.searches.map((search, index) => getRecentSearchEventProperties(search, (params.startIndex ?? 0) + index))
    });
};

export const trackPersonalizedHomepageRecentSearchClick = (params: {search: IPersonalizedRecentSearch; index: number}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_recent_search",
        buttonCategory: "homepage",
        itemId: null,
        value: "recent_search",
        additionalEventProperties: getRecentSearchEventProperties(params.search, params.index)
    });
};

export const trackPersonalizedHomepageRecentSearchesShowMore = (params: {label: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_recent_searches_show_more",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label
    });
};

export const trackPersonalizedHomepageOffersForYouClick = (params: {label: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_offers_for_you",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label.toUpperCase()
    });
};

export const trackPersonalizedHomepageYouTubeVideoClick = (params: {videoUrl?: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_youtube_video",
        buttonCategory: "homepage",
        itemId: null,
        value: "play_video",
        buttonLink: params.videoUrl ?? null
    });
};

export const trackPersonalizedHomepageYouTubeChannelClick = (params: {label: string; channelUrl: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_youtube_channel",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label.toUpperCase(),
        buttonLink: params.channelUrl
    });
};

export const trackPersonalizedHomepageConsultantCall = (params: {label: string; consultantName: string; phoneNumber: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_consultant_call",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label.toUpperCase(),
        buttonLink: params.phoneNumber,
        additionalEventProperties: {consultant_name: params.consultantName}
    });
};

export const trackPersonalizedHomepagePricesShowMore = (params: {label: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_prices_show_more",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label
    });
};

const getRecentSearchEventProperties = (search: IPersonalizedRecentSearch, index: number): Record<string, string | number | null> => ({
    index,
    search_label: search.title,
    rooms_label: search.roomsLabel,
    area_label: search.areaLabel,
    price_label: search.priceLabel,
    new_offers_label: search.newOffersLabel,
    search_recency: search.recencyLabel
});
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {trackAmplitudeViewSection} from "../../tracking/amplitude/track_amplitude_view_section";
import {IPersonalizedRecentSearch} from "../types/IPersonalizedHomepage";

/** Page-level impression of the personalized variant only — never sent for the generic homepage. */
export const trackPersonalizedHomepageViewPage = () => {
    trackAmplitudeEvent("view_page", {
        location: "homepage",
        homepage_variant: "personalized"
    });
};

export const trackPersonalizedHomepageRecentSearchesView = (params: {searches: IPersonalizedRecentSearch[]; startIndex?: number}) => {
    trackAmplitudeViewSection({
        sectionName: "recent_searches",
        location: "homepage",
        products: params.searches.map((search, index) => getRecentSearchEventProperties(search, (params.startIndex ?? 0) + index))
    });
};

export const trackPersonalizedHomepageRecentSearchClick = (params: {search: IPersonalizedRecentSearch; index: number}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_recent_search",
        buttonCategory: "homepage",
        itemId: null,
        value: "recent_search",
        additionalEventProperties: getRecentSearchEventProperties(params.search, params.index)
    });
};

export const trackPersonalizedHomepageRecentSearchesShowMore = (params: {label: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_recent_searches_show_more",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label
    });
};

export const trackPersonalizedHomepageOffersForYouClick = (params: {label: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_offers_for_you",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label.toUpperCase()
    });
};

export const trackPersonalizedHomepageYouTubeVideoClick = (params: {videoUrl?: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_youtube_video",
        buttonCategory: "homepage",
        itemId: null,
        value: "play_video",
        buttonLink: params.videoUrl ?? null
    });
};

export const trackPersonalizedHomepageYouTubeChannelClick = (params: {label: string; channelUrl: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_youtube_channel",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label.toUpperCase(),
        buttonLink: params.channelUrl
    });
};

export const trackPersonalizedHomepageConsultantCall = (params: {label: string; consultantName: string; phoneNumber: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_consultant_call",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label.toUpperCase(),
        buttonLink: params.phoneNumber,
        additionalEventProperties: {consultant_name: params.consultantName}
    });
};

export const trackPersonalizedHomepagePricesShowMore = (params: {label: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_prices_show_more",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label
    });
};

const getRecentSearchEventProperties = (search: IPersonalizedRecentSearch, index: number): Record<string, string | number | null> => ({
    index,
    search_label: search.title,
    rooms_label: search.roomsLabel,
    area_label: search.areaLabel,
    price_label: search.priceLabel,
    new_offers_label: search.newOffersLabel,
    search_recency: search.recencyLabel
});
